module.exports = __webpack_public_path__ + "img/whitepaper.f8472b07.png";